import addValidationMessage from '../utils/translation/addValidationMessage';

addValidationMessage('Core/requiredValidator', 'required', {
  fr: 'Champ obligatoire',
  en: 'Mandatory field',
});

addValidationMessage('Core/requiredValidator', 'recommended', {
  fr: 'Champ recommandé',
  en: 'Recommended field',
});

const requiredValidator = (value: unknown, { required = true } = {}) => (
  !required || (
    value !== null &&
    typeof value !== 'undefined' &&
    !Number.isNaN(value) &&
    value !== ''
  )
);

/**
 * @component
 * @visibleName requiredValidator
 */
export default requiredValidator;
